import React from "react";
import { useNavigate, Outlet } from "react-router-dom";
import { connect, useSelector } from "react-redux";
import { Row, Col } from "react-bootstrap";
import BaseLayout from "../../components/BaseLayout";
import { iconSupportCall, iconSupportPeople } from "../../utils/svg_assets";
import { supportContact, supportChat } from "../../utils/route_pages";
import { getIconFromOrg } from "../../utils/utilities";
import "./style.scss";

const HeaderSupport = () => (
  <div
    className="support-header"
    style={{
      backgroundImage: `url(${
        process.env.PUBLIC_URL + "/SKORE-Header-Bg.png"
      })`,
    }}
  >
    <div className="support-header-label">Support</div>
  </div>
);

const ContentItem = ({ imgsrc, children, onClick }) => {
  return (
    <Row
      onClick={() => (onClick !== undefined ? onClick() : console.log("here"))}
    >
      <Col xs={3} sm={2} md={2}>
        <div className="support-img-container">
          <center>
            <img src={imgsrc} alt="content_item_image" />
          </center>
        </div>
      </Col>
      <Col xs={9} sm={10} md={10} className="zeropm">
        <div className="support-content-item">{children}</div>
      </Col>
    </Row>
  );
};

const SupportPage = (props) => {
  const { pwa_setting } = props;
  const navigate = useNavigate();
  const orgData = useSelector((state) => state.LoginSM.orgData);

  return (
    <BaseLayout
      show_menu={pwa_setting.show_main_menu}
      bottomNavIndex={3}
      header={<HeaderSupport />}
    >
      <div className="support-content">
        <h4 className="support-content-title">Need help with the app?</h4>
        <br />
        <ContentItem
          imgsrc={
            Object.keys(orgData).length > 0
              ? getIconFromOrg(orgData, "icon_support_chat")
              : iconSupportPeople
          }
          onClick={() => navigate(supportChat)}
        >
          <h6>Chat for Technical/Merchant Support</h6>
          <p>
            Chat with our customer service about technical issues or
            merchant/rewards support
          </p>
        </ContentItem>
        <br />
        <ContentItem
          imgsrc={
            Object.keys(orgData).length > 0
              ? getIconFromOrg(orgData, "icon_support_contact")
              : iconSupportCall
          }
          onClick={() => navigate(supportContact)}
        >
          <h6>Contact </h6>
          <p>Contact through phone or email</p>
        </ContentItem>
        <Outlet />
      </div>
    </BaseLayout>
  );
};

const mapStateToProps = (state) => ({
  pwa_setting: state.LoginSM.login.organization_pwa_settings,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(SupportPage);
